import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OutingIterationDetailsService } from 'src/app/administration/outings/outing-iteration-details.service';
import { OutingIterationDetails } from 'src/app/administration/outings/outing-iteration-details/outing-iteration-details';

@Component({
    selector: 'edit-outing-iteration-detail-modal',
    templateUrl: './edit-outing-iteration-detail-modal.component.html',
    styleUrls: ['./edit-outing-iteration-detail-modal.component.scss'],
    standalone: false
})
export class EditOutingIterationDetailModalComponent implements OnInit {
  detail: OutingIterationDetails = new OutingIterationDetails();
  isSaving: boolean;
  submitText: string;

  constructor(public diaglogRef: MatDialogRef<EditOutingIterationDetailModalComponent>,
    private outingIterationDetailService: OutingIterationDetailsService) { }

  ngOnInit() {
    let component = this;
    let k = 1;
  }

  submit() {
    this.isSaving = true;
    this.outingIterationDetailService.update(this.detail.id, this.detail).subscribe(() => {
      this.diaglogRef.close(this.submitText);
      this.isSaving = false;
    }, err =>{
      this.isSaving = false;
    });
  }

  cancel() {
    this.diaglogRef.close();
  }

}
